import { getAdminLenderUserListAsync } from '../methods/getAdminLenderUserListAsync';
import { eApplicationActions } from './eApplicationActions';
import { IApplicationActions } from './IApplicationActions';
import { Logger } from '../../../ui-toolkit/logging/LoggerService';

export const getLenderUserListAsyncAction = async (lender_id: string): Promise<IApplicationActions> => {
  try {
    const results = await getAdminLenderUserListAsync(lender_id);
    return { type: eApplicationActions.SetLenderUserList, payload: results };
  } catch (e: any) {
    Logger.error('Unable to load admin lender list for lender id:' + lender_id, e);
    return {
      type: eApplicationActions.ChangeValues,
      payload: { error: 'Unable to load lender users for the given lender id' },
    };
  }
};
